import styled from '@emotion/styled';
import { Link } from 'components/link';
import { MOBILE_SUBHEADER_HEIGHT } from 'components/navigation/header.constants';
import { SmallText, Text } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';


export const BackButtonWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: scaleX(-1);
`;

export const Inner = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(Text)<{ show: boolean }>`
  transition: opacity .2s ease;
  opacity: ${({ show }) => show ? 1 : 0};
`;

export const Name = styled(Text.withComponent('h1'))`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 280px;
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  padding: 0 ${({ theme }) => theme.spacing(5)};
  span {
    color: ${({ theme }) => theme.colors.neutrals.grey2};
  }
`;

export const InfoWrapper = styled.div``;

export const NavigationWrapper = styled.div`
  position: sticky;
  top: ${MOBILE_SUBHEADER_HEIGHT}px;
  z-index: 3;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
`;

export const OfficeInfo = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(3)}`};
  background-color: ${({ theme }) => theme.colors.neutrals.grey11};
  text-decoration: none;
`;

export const OfficeLogo = styled.div`
  overflow: hidden;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  ${({ theme }) => `
    width: 48px;
    height: 48px;
    padding: ${theme.spacing(0.25)};
    box-shadow: 0 2px 5px 0 ${colorToAlpha(theme.colors.neutrals.black, 0.1)};
    background: ${theme.colors.neutrals.white};
  `}
`;

export const OfficeName = styled(SmallText)`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
`;
